export default __webpack_public_path__ + "static/media/safa.fab26b6d.png";